module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "col-3",
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-success btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("Add new order")])]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.orders), function(order, n) {
    return _c('a', {
      key: n,
      staticClass: "list-group-item list-group-item-action flex-column align-items-start",
      class: {
        'active': order.hovered, 'list-group-item-danger': (!order.reservation.reservationTables || !order.reservation.reservationTables.length), 'list-group-item-success': order.reservation.isArrived
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editOrder(order)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h6', {
      staticClass: "mb-1"
    }, [(order.icon) ? _c('div', {
      staticClass: "fa",
      class: 'fa-' + order.icon
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm._f("time")(order.reservation.reservationDate)) + "-" + _vm._s(order.reservation.leavingTime) + "\n              "), (order.reservation.fullname) ? _c('span', [_vm._v("\n              - " + _vm._s(order.reservation.fullname) + "\n              ")]) : _vm._e(), _vm._v(" "), (order.reservation.totalCountForClient > 1) ? _c('span', {
      staticClass: "fa fa-star"
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Room: " + _vm._s(_vm.roomName(order.reservation.reservationRoom)) + ", tables: " + _vm._s((order.reservation.reservationTables || []).join(', ')))])]), _vm._v(" "), _c('small', [_vm._v("\n              " + _vm._s(order.reservation.partySize) + "\n              "), (order.reservation.partySize === 1) ? _c('span', [_vm._v("person")]) : _c('span', [_vm._v("people")])])])])
  }), _vm._v(" "), (!_vm.orders.length) ? _c('span', [_c('el-alert', {
    attrs: {
      "center": "",
      "closable": false,
      "title": "No orders",
      "type": "info"
    }
  })], 1) : _vm._e()], 2)])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    attrs: {
      "id": "cc"
    }
  }, [_c('img', {
    attrs: {
      "id": "i"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "c"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ffd2154"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/ViewRoom.vue
// module id = 426
// module chunks = 4